/**
 * Created by DynamicDog on 2017-02-20.
 */
import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
@Component({
    selector: 'priser-panel',
    template: `
            <div id="priser-panel">
            <h1>{{'Fina priser till vinnarna'|translate}}</h1>
            <img src="images/competition1.png">
            <h1>{{'1:an - Resa till Gränna'|translate}}</h1>
            <p>{{'Lorem ipsum dolor sit amet, iuvaret expetenda gloriatur usu ne, eros splendide deterruisset ei
nec. Mea facer legere an. Eam no solum altera, vix ut mundi iracundia appellantur. Habeo
fugit aperiam at pri. Per cu eius lorem animal. Et utroque erroribus voluptatum has, nec an
duis accommodare.'|translate}}</p>
            <img src="image/competition2.png">
            <h1>{{'2:an – Pralinkurs'|translate}}</h1>
            <p>{{'Lorem ipsum dolor sit amet, iuvaret expetenda gloriatur usu ne, eros splendide deterruisset ei
nec. Mea facer legere an. Eam no solum altera, vix ut mundi iracundia appellantur. Habeo
fugit aperiam at pri. Per cu eius lorem animal. Et utroque erroribus voluptatum has, nec an
duis accommodare'|translate}}</p>
            </div>
        `,
})

export class PriserPanelComponent {
    constructor(private etikettService:EtikettService) {

    }

    private onUpload() {
    }
}


// WEBPACK FOOTER //
// ./app/upload/priserpanel.component.ts